import { RouteConfig } from 'vue-router'
import { seoRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const SeoIndexApp = () => import('@/pmd/pages/seo/SeoIndexApp.vue').then(m => m.default)

export const seoRoute: RouteConfig[] = [
  {
    path: 'seo',
    name: seoRouteNames.default,
    component: SeoIndexApp,
    beforeEnter: requireAuthAndLocation,
  },
]
